@if (isOpen()) {
  <button
    type="button"
    class="global-assist-backdrop"
    aria-label="Close assistant"
    (click)="close()"
  ></button>
}

<section
  id="global-assist-panel"
  class="global-assist-panel"
  [class.open]="isOpen()"
  [class.dragging]="isDragging"
  [style.width.px]="widthPx()"
  [attr.aria-hidden]="isOpen() ? null : true"
  aria-label="Global assistant"
  (click)="$event.stopPropagation()"
>
  <div class="global-assist-panel__inner">
    <div class="global-assist-panel__header">
      <h2 class="global-assist-panel__title">Assistant</h2>
      <button
        type="button"
        class="global-assist-close"
        aria-label="Close assistant"
        (click)="close(); $event.stopPropagation()"
      >
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>
    <div class="global-assist-panel__chat">
      <app-chat
        [conversationId]="store.activeProjectId()"
        [context]="chatContext"
        [modelSurfaceKey]="'chat.global'"
        [orchestratorPageContext]="orchestratorPageContext()"
        [initialMessages]="globalChat.chatMessages()"
        [placeholder]="'Ask about this project or say hello…'"
        (messagesChange)="onMessagesChange($event)"
        (messageCreated)="onMessageCreated($event)"
      />
    </div>
  </div>
  <div
    class="global-assist-resize-edge"
    role="separator"
    aria-orientation="vertical"
    aria-label="Resize assistant panel"
    [attr.tabindex]="isOpen() ? 0 : -1"
    (pointerdown)="onResizePointerDown($event)"
  ></div>
</section>
